class TokenService {
  getLocalRefreshToken() {
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      return token?.refreshToken;
    } catch (error) {
      return null;
    }
  }
  getLocalAccessToken() {
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      return token?.accessToken;
    } catch (error) {
      return null;
    }
  }
  updateLocalAccessToken(accessToken) {
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      token.accessToken = accessToken;
      localStorage.setItem('token', JSON.stringify(token));
    } catch (error) {
      return null;
    }
  }
  getToken() {
    try {
      return JSON.parse(localStorage.getItem('token'));
    } catch (error) {
      return null;
    }
  }
  setToken(token) {
    localStorage.setItem('token', JSON.stringify(token));
  }
  setUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }
  getUser() {
    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch (error) {
      return null;
    }
  }
  removeUser() {
    localStorage.removeItem('user');
  }
  removeToken() {
    localStorage.removeItem('token');
  }
}

const tokenService = new TokenService();
export default tokenService;
